import { SkeletonProvider } from './SkeletonProvider';
export class ViagogoConnectorDefinition extends SkeletonProvider { constructor() { super({ id: 'viagogo', name: 'Viagogo', authStrategy: 'oauth2', documentationUrl: 'https://developer.viagogo.net/' }); } }
